<div class="ddl-wrapper" (click)="optionVisibility = true" tabindex="0" role="button" (keyup.enter)="$event.target.click()">
  <p class="ddl-label" [innerHTML]="dropdownData.label"></p>
  <div class="ddl-value">
    <span class="hover-element text-truncate" title="{{ selectedOption }}">{{ selectedOption }}</span>
    <i class="icon-dropdown float-right" aria-hidden="true"></i>
    <span class="sr-only">Toggle Dropdown</span>
  </div>
  @if (optionVisibility) {
    <div class="ddl-option-wrapper">
      <ul>
        @for (opt of dropdownData.option; track opt; let i = $index) {
          <li [class.selected]="selectedOption === opt" id="year_{{ i + 1 }}" (click)="onChange(opt); optionVisibility = false" tabindex="0" role="button" (keyup.enter)="$event.target.click()">
            {{ opt }}
          </li>
        }
      </ul>
    </div>
  }
</div>
